import * as React from "react";
import { Button } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { useEventManagerStyles } from "./eventManagerStyles";
import { utc } from "./utcDate";

const RESULT_LABELS = { sent: "Sent", skipped: "Skipped" };

const pushTitle = (p) => {
	if (p.status === "sent") {
		return `Sent ${utc(p.sentAt)} UTC, delivered to ${p.deliveredCount}`;
	}
	return p.status === "skipped" ? "Skipped, no push went out" : "Not sent yet";
};

export default function NotificationsTab({ event, canSend, onSendPush }) {
	const classes = useEventManagerStyles();
	const stages = event.stages ?? [];
	const results = event.resultsPush ?? {};

	const pillClass = (p) => {
		if (p.status === "sent") {
			return `${classes.pill} ${classes.pillText} ${classes.pillSent}`;
		}
		if (p.status === "skipped") {
			return `${classes.pill} ${classes.pillText} ${classes.pillDim}`;
		}
		return `${classes.pill} ${classes.pillText} ${classes.pillPending}`;
	};

	const stagePill = (stage, push) => (
		<span
			key={stage.stageIndex}
			className={pillClass(push)}
			title={pushTitle(push)}
		>
			{push.status === "sent" ? <Check fontSize="inherit" /> : null}
			{stage.name}
		</span>
	);

	return (
		<div className={classes.rowGrid}>
			{stages.length ? (
				<>
					<span className={classes.rowLabel}>Picks open</span>
					<div className={classes.pills}>
						{stages.map((s) => stagePill(s, s.picksOpenPush))}
						{canSend ? (
							<Button variant="contained" color="primary" onClick={onSendPush}>
								Send push
							</Button>
						) : null}
					</div>
					<span className={classes.rowLabel}>Reminder</span>
					<div className={classes.pills}>
						{stages.map((s) => stagePill(s, s.reminderPush))}
					</div>
				</>
			) : null}
			<span className={classes.rowLabel}>Results</span>
			<div className={classes.pills}>
				<span className={pillClass(results)} title={pushTitle(results)}>
					{results.status === "sent" ? <Check fontSize="inherit" /> : null}
					{RESULT_LABELS[results.status] ?? "Not sent"}
				</span>
			</div>
		</div>
	);
}
